<template>
    <div>
        <div class="d-flex text-primary">
            <h3> {{ $t('statistics.title') }} </h3>
        </div>
        <div class="divider"></div>

        <div class="row">
            <div class="col-10 col-sm-4 col-md-2 mt-2">
                <h5 style="font-size: 14px"> {{ $t('statistics.categories.ourDebt') }} </h5>
            </div>
            <div class="col-12 col-sm-8 col-md-3 mt-2 btn-group btn-group-toggle" data-toggle="buttons">
                <label class="btn btn-primary button-stat active">
                    <input type="radio" name="options" @click="debtDaily" checked> {{ $t('statistics.type.statByDay') }}
                </label>
                <label class="btn btn-primary button-stat">
                    <input type="radio" name="options" @click="debtMonthly"> {{ $t('statistics.type.statByMonth') }}
                </label>
                <label class="btn btn-primary button-stat">
                    <input type="radio" name="options" @click="debtAnnual"> {{ $t('statistics.type.statByYear') }}
                </label>
            </div>
            <div class="col-12 col-sm-8 col-md-7 mt-2">
                <div class="row">
                    <div :class="byMonth || byYear ? 'd-block col-12 col-sm-8 d-flex select-form' : 'd-none'">
                        <b-form-select
                            v-if="byYear"
                            class="mb-2"
                            v-model="selectedYear"
                            :options="optionsYear"
                            @change="debtAnnual"
                            size="sm">
                        </b-form-select>
                        <b-form-select
                            v-if="byMonth"
                            class="mr-4 mb-2"
                            v-model="selectedYear"
                            :options="optionsYear"
                            size="sm">
                        </b-form-select>
                        <b-form-select
                            v-if="byMonth"
                            v-model="selectedMonth"
                            :options="optionsMonth"
                            @change="debtMonthly"
                            size="sm">
                        </b-form-select>
                    </div>
                    <div v-if="datePicker" class="col-12 col-sm-8 col-lg-6 col-xl-5">
                        <b-form-datepicker
                            id="example-datepicker"
                            size="sm"
                            v-model="currentDate"
                            class="mb-2"
                            :hide-header="hideHeader"
                            @input="debtDaily"
                        ></b-form-datepicker>
                    </div>
                    <div class="col-12 col-sm-4">
                        <b-form-select
                            @change="callStatByPeriod"
                            v-model="modelFormCurrency"
                            size="sm"
                        >
                            <b-form-select-option value="UZS">UZS</b-form-select-option>
                            <b-form-select-option value="USD">USD</b-form-select-option>
                            <b-form-select-option value="RUB">RUB</b-form-select-option>
                        </b-form-select>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="main-chart col-11">
                <AreaChart :series="series" :options="chartOptions" :height=450 />
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="indicators-bar col-12">
                <div class="row justify-content-center">
                    <div class="col-12 col-sm-6 col-md-2 indicator">
                        <div class="indicator-title">{{ $t('statistics.categories.totalSale') }}</div>
                        <div class="indicator-range">
                            <span v-if="!this.hasIncreaseTotalSale">-</span>
                            {{ numberWithCommas(Math.round(Math.abs(this.diffTotalSale))) }}%
                            <span v-if="!isNaN(this.diffTotalSale)">
                                <img v-if="!this.hasIncreaseTotalSale" src="/promo/img/Vector24.png" alt="photo">
                                <img v-else-if="this.diffTotalSale !== 0" src="/promo/img/Vector22.png" alt="photo">
                            </span>
                        </div>
                        <div v-if="isUZS" class="indicator-total">
                            {{ numberWithCommas(Math.floor(this.totalSale)) }} UZS
                        </div>
                        <div v-if="isUSD || isRUB" class="indicator-total">
                            {{ numberWithCommas(this.totalSale) }}
                            <span v-if="isUSD">USD</span>
                            <span v-if="isRUB">RUB</span>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-2 indicator">
                        <div class="indicator-title">{{ $t('statistics.categories.cash') }}</div>
                        <div class="indicator-range">
                            <span v-if="!this.hasIncreaseCash">-</span>
                            {{ numberWithCommas(Math.round(Math.abs(isNaN(this.diffCash) ? 0 : this.diffCash))) }}%
                            <span v-if="!isNaN(this.diffCash)">
                                <img v-if="!this.hasIncreaseCash" src="/promo/img/Vector24.png" alt="photo">
                                <img v-else-if="this.diffCash !== 0" src="/promo/img/Vector22.png" alt="photo">
                            </span>
                        </div>
                        <div v-if="isUZS" class="indicator-total">
                            {{ numberWithCommas(Math.floor(this.cash)) }} UZS
                        </div>
                        <div v-if="isUSD || isRUB" class="indicator-total">
                            {{ numberWithCommas(this.cash) }}
                            <span v-if="isUSD">USD</span>
                            <span v-if="isRUB">RUB</span>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-2 indicator">
                        <div class="indicator-title">{{ $t('statistics.categories.bankCard') }}</div>
                        <div class="indicator-range">
                            <span v-if="!this.hasIncreaseBankCard">-</span>
                            {{ numberWithCommas(Math.round(Math.abs(isNaN(this.diffBankCard) ? 0 : this.diffBankCard))) }}%
                            <span v-if="!isNaN(this.diffBankCard)">
                                <img v-if="!this.hasIncreaseBankCard" src="/promo/img/Vector24.png" alt="photo">
                                <img v-else-if="this.diffBankCard !== 0" src="/promo/img/Vector22.png" alt="photo">
                            </span>
                        </div>

                        <div v-if="isUZS" class="indicator-total">
                            {{ numberWithCommas(Math.floor(this.bankCard)) }} UZS
                        </div>
                        <div v-if="isUSD || isRUB" class="indicator-total">
                            {{ numberWithCommas(this.bankCard) }}
                            <span v-if="isUSD">USD</span>
                            <span v-if="isRUB">RUB</span>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6 col-md-2 indicator">
                        <div class="indicator-title">{{ $t('statistics.categories.moneyTransfer') }}</div>
                        <div class="indicator-range">
                            <span v-if="!this.hasIncreaseMoneyTransfer">-</span>
                            {{ numberWithCommas(Math.round(Math.abs(isNaN(this.diffMoneyTransfer) ? 0 : this.diffMoneyTransfer))) }}%
                            <span v-if="!isNaN(this.diffMoneyTransfer)">
                                <img v-if="!this.hasIncreaseMoneyTransfer" src="/promo/img/Vector24.png" alt="photo">
                                <img v-else-if="this.diffMoneyTransfer !== 0" src="/promo/img/Vector22.png" alt="photo">
                            </span>
                        </div>

                        <div v-if="isUZS" class="indicator-total">
                            {{ numberWithCommas(Math.floor(this.moneyTransfer)) }} UZS
                        </div>
                        <div v-if="isUSD || isRUB" class="indicator-total">
                            {{ numberWithCommas(this.moneyTransfer) }}
                            <span v-if="isUSD">USD</span>
                            <span v-if="isRUB">RUB</span>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6 col-md-2 indicator">
                        <div class="indicator-title">{{ $t('statistics.categories.debt') }}</div>
                        <div class="indicator-range">
                            <span v-if="!this.hasIncreaseDebt">-</span>
                            {{ numberWithCommas(Math.round(Math.abs(isNaN(this.diffDebt) ? 0 : this.diffDebt))) }}%
                            <span v-if="!isNaN(this.diffDebt)">
                                <img v-if="!this.hasIncreaseDebt" src="/promo/img/Vector24.png" alt="photo">
                                <img v-else-if="diffDebt !== 0" src="/promo/img/Vector22.png" alt="photo">
                            </span>
                        </div>
                        <div v-if="isUZS" class="indicator-total">
                            {{ numberWithCommas(Math.floor(this.debt)) }} UZS
                        </div>
                        <div v-if="isUSD || isRUB" class="indicator-total">{{ numberWithCommas(this.debt) }}
                            <span v-if="isUSD">USD</span>
                            <span v-if="isRUB">RUB</span>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-2 indicator">
                        <div class="indicator-title">{{ $t('statistics.categories.profit') }}</div>
                        <div class="indicator-range">
                            <span v-if="!this.hasIncreaseIncome">-</span>
                            {{ numberWithCommas(Math.round(Math.abs(isNaN(this.diffIncome) ? 0 : this.diffIncome))) }}%
                            <span v-if="!isNaN(this.diffIncome)">
                                <img v-if="!this.hasIncreaseIncome" src="/promo/img/Vector24.png" alt="photo">
                                <img v-else-if="this.diffIncome !== 0" src="/promo/img/Vector22.png" alt="photo">
                            </span>
                        </div>
                        <div v-if="isUZS" class="indicator-total">
                            {{ numberWithCommas(Math.floor(this.income)) }} UZS
                        </div>
                        <div v-if="isUSD || isRUB" class="indicator-total">
                            {{ numberWithCommas(this.income) }}
                            <span v-if="isUSD">USD</span>
                            <span v-if="isRUB">RUB</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-11">
                <div class="row justify-content-center">
                    <router-link to="/:lang/statistics/sale" class="card  mr-0 mr-sm-4 mt-4">
                        <ColumnChart :series="saleSeries"/>
                    </router-link>
                    <div class="active m-0 mr-sm-4 mt-4 card">
                        <ColumnChartDebt :activate-chart="activateChart" :series="debtSeries"/>
                    </div>
                    <router-link to="/:lang/statistics/ex-debt" class="card m-0 mr-md-4 mt-4">
                        <ColumnChartExDebt :series="exDebtSeries"/>
                    </router-link>
                    <router-link :to="$i18nHelper.getUrl('statistics/employee/') + this.employeeId" class="card m-0 mr-sm-4 ml-sm-4 ml-md-0 mt-4">
                        <ColumnChartEmployee :series="exDebtSeries" :height="10" />
                    </router-link>
                </div>
            </div>
        </div>

        <div class="row mt-4 justify-content-center">
            <div class="col-11">
                <div class="row justify-content-around">
                    <div class="col-11 card-pay-type">
                        <div class="indicator-title py-2">
                            {{ $t('statistics.payTypes') }}
                        </div>
                        <div class="row d-flex justify-content-between px-4 mb-2">
                            <div class="subtitle">{{ $t('statistics.categories.cash') }}</div>
                            <b-progress class="progress" :value="this.getCompanyPayTypeStatistics.cashPercent" :max="max"></b-progress>
                            <div class="percent">{{ this.getCompanyPayTypeStatistics.cashPercent }}%</div>
                        </div>
                        <div class="row d-flex justify-content-between px-4 mb-2">
                            <div class="subtitle">{{ $t('statistics.categories.debt') }}</div>
                            <b-progress :value="this.getCompanyPayTypeStatistics.debtPercent" :max="max"></b-progress>
                            <div class="percent">{{ this.getCompanyPayTypeStatistics.debtPercent }}%</div>
                        </div>
                        <div class="row d-flex justify-content-between px-4 mb-2">
                            <div class="subtitle">{{ $t('statistics.categories.bankCard') }}</div>
                            <b-progress :value="this.getCompanyPayTypeStatistics.bankCardPercent" :max="max"></b-progress>
                            <div class="percent">{{ this.getCompanyPayTypeStatistics.bankCardPercent }}%</div>
                        </div>
                        <div class="row d-flex justify-content-between px-4 mb-2">
                            <div class="subtitle">{{ $t('statistics.categories.moneyTransfer') }}</div>
                            <b-progress :value="this.getCompanyPayTypeStatistics.moneyTransferPercent" :max="max"></b-progress>
                            <div class="percent">{{ this.getCompanyPayTypeStatistics.moneyTransferPercent }}%</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="row mt-4 justify-content-center">
            <div class="col-11">
                <SearchCollapse class="">
                    <div class="d-none d-md-block">
                        <div class="row">
                            <div class="col-3 indicator-title">{{ $t('statistics.employee.employee') }}</div>
                            <div class="col-2 text-center indicator-title">{{ $t('sale.title') }}</div>
                            <div class="col-4 text-center indicator-title">{{ $t('statistics.employee.activity') }}(%)</div>
                            <div class="col-2 indicator-title"></div>
                        </div>
                    </div>

                    <div v-for="(employee, index) of this.getCompanyEmployeesSale" :key="index" class="row employee-card mt-1">

                        <div  class="col-12 col-md-3 p-0 ml-3 employee d-flex">
                            <div v-if="employee.imageUrl !== null" class="img float-left">
                                <img class="picture" :src="url + '/pictures/' + employee.imageUrl">
                            </div>
                            <div v-else class="img float-left">
                                <img class="picture" src="../../assets/anonym.png">
                            </div>
                            <div class="employee-title d-flex align-items-center float-left">
                                <div class="pl-3">
                                    <div class="employee-name" style="line-height: 1">{{ employee.givenName }} {{ employee.familyName }}</div>
                                    <div class="position">{{ employee.position }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="modelFormCurrency === 'UZS'"
                             class="col-12 col-md-2 employee-sale d-flex align-items-center justify-content-center">
                            {{ Math.floor(employee.sale) }} UZS
                        </div>
                        <div v-if="modelFormCurrency === 'USD'"
                             class="col-12 col-md-2 employee-sale d-flex align-items-center justify-content-center">
                            {{ numberWithCommas((parseInt(employee.sale) / parseFloat(rateUSD)).toFixed(2)) }} USD
                        </div>
                        <div v-if="modelFormCurrency === 'RUB'"
                             class="col-12 col-md-2 employee-sale d-flex align-items-center justify-content-center">
                            {{ numberWithCommas((parseInt(employee.sale) / parseFloat(rateRUB)).toFixed(2)) }} RUB
                        </div>
                        <div class="col-12 col-md-3 ml-2 employee-activity d-flex align-items-center justify-content-center">
                            <b-progress class="progress w-75 ml-3" :value="employee.activity" :max="max"></b-progress>
                            <span class="pl-2 mr-n2">{{employee.activity}}%</span>
                        </div>
                        <div class="col-12 col-md-3 employee-statistics d-flex align-items-center justify-content-center">
                            <b-button
                                :to="'/:lang/statistics/employee/' + employee.id"
                                variant="primary"
                                class="w-75"
                                size="sm"
                            >
                                {{ $t('plan.statistics') }}
                            </b-button>
                        </div>

                    </div>
                </SearchCollapse>
            </div>
        </div>

    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import Vue from "vue";
import ColumnChart from "@/pages/Statistics/Charts/ColumnChart";
import AreaChart from "@/pages/Statistics/Charts/AreaChart";
import ColumnChartDebt from "@/pages/Statistics/Charts/ColumnChartDebt";
import ColumnChartExDebt from "@/pages/Statistics/Charts/ColumnChartExDebt";
import {mapActions, mapGetters} from "vuex";
import currencyFormat from "@/mixin/currencyFormatMixin";
import SearchCollapse from "@/components/SearchCollapse";
import ColumnChartEmployee from "@/pages/Statistics/Charts/ColumnChartEmployee";
import currencyRateMixin from "@/mixin/currencyRateMixin";

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

export default {
    name: "DebtShow",
    components: {ColumnChartExDebt, ColumnChartDebt, AreaChart, ColumnChart, SearchCollapse, ColumnChartEmployee},
    mixins: [currencyFormat, currencyRateMixin],
    data() {
        return {
            url: process.env.VUE_APP_API_URL,
            max: 100,
            activateChart: true,
            byMonth: false,
            byYear: false,
            datePicker: false,
            currentMonth: '',
            sumSale: 0,
            totalSale: 0,
            cash: 0,
            debt: 0,
            income: 0,
            bankCard: 0,
            moneyTransfer: 0,
            hideHeader: false,
            currentDate: '',
            modelFormCurrency: 'UZS',
            employeeId: null,
            search: {
                startDate: '',
                endDate: '',
                isPayed: null,
                employeeId: null,
                isDaily: false,
                isMonthly: false,
            },
            diffTotalSale: 0,
            diffCash: 0,
            diffDebt: 0,
            diffIncome: 0,
            diffBankCard: 0,
            diffMoneyTransfer: 0,
            hasIncreaseTotalSale: false,
            hasIncreaseCash: false,
            hasIncreaseDebt: false,
            hasIncreaseIncome: false,
            hasIncreaseBankCard: false,
            hasIncreaseMoneyTransfer: false,
            isRUB: false,
            isUSD: false,
            isUZS: true,
            rateUSD: null,
            rateRUB: null,
            selectedMonth: null,
            selectedYear: null,
            optionsMonth: [
                {value: {start: '01-01', end: '01-31'}, text: this.$t('statistics.month.Jan')},
                {value: {start: '02-01', end: '02-28'}, text: this.$t('statistics.month.Feb')},
                {value: {start: '03-01', end: '03-31'}, text: this.$t('statistics.month.Mar')},
                {value: {start: '04-01', end: '04-30'}, text: this.$t('statistics.month.Apr')},
                {value: {start: '05-01', end: '05-31'}, text: this.$t('statistics.month.May')},
                {value: {start: '06-01', end: '06-30'}, text: this.$t('statistics.month.Jun')},
                {value: {start: '07-01', end: '07-31'}, text: this.$t('statistics.month.Jul')},
                {value: {start: '08-01', end: '08-31'}, text: this.$t('statistics.month.Aug')},
                {value: {start: '09-01', end: '09-30'}, text: this.$t('statistics.month.Sep')},
                {value: {start: '10-01', end: '10-31'}, text: this.$t('statistics.month.Oct')},
                {value: {start: '11-01', end: '11-30'}, text: this.$t('statistics.month.Nov')},
                {value: {start: '12-01', end: '12-31'}, text: this.$t('statistics.month.Dec')},
            ],
            optionsYear: [],

            //chart options started
            chartOptions: {
                chart: {
                    id: '1',
                    type: 'area',
                    toolbar: {
                        show: false,
                    }
                },
                colors: ['#6f42c1'],
                dataLabels: {
                    enabled: false,
                },
                stroke: {},
                xaxis: {
                    min: 1,
                    title: {
                        text: this.$t('statistics.xaxis.hour') + '/' + this.$t('statistics.xaxis.day'),
                        offsetX: 0,
                        offsetY: -10,
                        style: {
                            color: '#6f42c1',
                            fontSize: '12px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 600,
                            cssClass: 'apexcharts-xaxis-title',
                        },
                    },
                },
                yaxis: {
                    decimalsInFloat: 0,
                    title: {
                        text: this.$t('statistics.yaxis'),
                        offsetX: 5,
                        offsetY: 0,
                        style: {
                            color: '#6f42c1',
                            fontSize: '12px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 600,
                            cssClass: 'apexcharts-xaxis-title',
                        },
                    },
                    tickAmount: 15,
                },
                responsive: [
                    {
                        breakpoint: 500,
                        options: {
                            chart: {
                                height: 300,
                                width: '110%',
                                type: 'area',
                                toolbar: {
                                    show: true,
                                }
                            },
                            xaxis: {
                                labels: {
                                    show: true,
                                    style: {
                                        fontSize: '8px',
                                        fontFamily: 'Helvetica, Arial, sans-serif',
                                        fontWeight: 400,
                                        cssClass: 'apexcharts-xaxis-label',
                                    },
                                },
                                title: {
                                    show: false,
                                    text: '',
                                },
                            },
                            yaxis: {
                                title: {
                                    show: false,
                                    text: '',
                                },
                                tickAmount: 10,
                                labels: {
                                    style: {
                                        fontSize: '8px',
                                        fontFamily: 'Helvetica, Arial, sans-serif',
                                        fontWeight: 400,
                                        cssClass: 'apexcharts-yaxis-label',
                                    },
                                }
                            },
                        },
                    },
                ]
            },

            //AreaChart
            saleSeries: [{
                name: 'series1',
                data: [15, 22, 56, 20, 66, 85, 80, 30, 46, 55, 42]
            }],

            //chart column
            debtSeries: [{
                data: []
            }],

            //array for exDebt
            exDebtSeries: [{
                name: this.$t('statistics.categories.ourDebt'),
                data: [58, 45, 66, 25, 16, 40, 60, 30, 66, 55, 42]
            }],

            //function series
            series: [{
                name: this.$t('statistics.categories.ourDebt'),
                data: []
            }],

            //array for day stats
            day: [{
                name: this.$t('statistics.categories.ourDebt'),
                data: []
            }],

            //array for month stats
            month: [{
                name: this.$t('statistics.categories.ourDebt'),
                data: []
            }],

            //array for year stats
            year: [{
                name: this.$t('statistics.categories.ourDebt'),
                data: []
            }],
        }
    },
    computed: {
        ...mapGetters([
            'getProductPurchases',
            'getCompany',
            'getUser',
            'getUserCompanyCreatedAt',
            'getUserCompanyId',
            'getCompanyStatistics',
            'getCompanyPastStatistics',
            'getCompanyPayTypeStatistics',
            'getCompanyEmployeesSale'
        ])
    },
    methods: {
        ...mapActions([
            'searchProductPurchase',
            'fetchCompany',
            'fetchUser',
            'fetchCompanyStatistics',
            'fetchCompanyPastStatistics',
            'fetchCompanyPayTypeStatistics',
            'fetchCompanyEmployeesSales'
        ]),
        callStatByPeriod() {
            if (this.datePicker) {
                this.debtDaily()
            } else if (this.byMonth) {
                this.debtMonthly()
            } else {
                this.debtAnnual()
            }
        },
        exchangeTotalSaleToUSD() {
            this.totalSale = this.calculateAmountByBaseCurrency(this.totalSale, "UZS", "USD")
        },
        exchangeCashToUSD() {
            this.cash = this.calculateAmountByBaseCurrency(this.cash, "UZS", "USD")
        },
        exchangeBankCardToUSD() {
            this.bankCard = this.calculateAmountByBaseCurrency(this.bankCard, "UZS", "USD")
        },
        exchangeMoneyTransferToUSD() {
            this.moneyTransfer = this.calculateAmountByBaseCurrency(this.moneyTransfer, "UZS", "USD")
        },
        exchangeDebtToUSD() {
            this.debt = this.calculateAmountByBaseCurrency(this.debt, "UZS", "USD")
        },
        exchangeIncomeToUSD() {
            this.income = this.calculateAmountByBaseCurrency(this.income, "UZS", "USD")
        },
        exchangeTotalSaleToRUB() {
            this.totalSale = this.calculateAmountByBaseCurrency(this.totalSale, "UZS", "RUB")
        },
        exchangeCashToRUB() {
            this.cash = this.calculateAmountByBaseCurrency(this.cash, "UZS", "RUB")
        },
        exchangeBankCardToRUB() {
            this.bankCard = this.calculateAmountByBaseCurrency(this.bankCard, "UZS", "RUB")
        },
        exchangeMoneyTransferToRUB() {
            this.moneyTransfer = this.calculateAmountByBaseCurrency(this.moneyTransfer, "UZS", "RUB")
        },
        exchangeDebtToRUB() {
            this.debt = this.calculateAmountByBaseCurrency(this.debt, "UZS", "RUB")
        },
        exchangeIncomeToRUB() {
            this.income = this.calculateAmountByBaseCurrency(this.income, "UZS", "RUB")
        },
        debtDaily() {
            this.byMonth = false
            this.byYear = false
            this.datePicker = true
            this.series = []
            this.debtSeries = []
            let date = new Date(this.currentDate)
            this.search.startDate = date.toISOString()
            this.search.endDate = this.currentDate + ' ' + '18:59:59'

            this.searchProductPurchase(this.search)
                .then(() => {
                    this.fetchCompanyPayTypeStatistics(this.search)
                    this.fetchCompanyEmployeesSales(this.search)
                    this.fetchCompanyStatistics(this.search)
                        .then(() => {
                            this.totalSale = this.getCompanyStatistics.totalSaleCurrentDay
                            this.cash = this.getCompanyStatistics.cash
                            this.debt = this.getCompanyStatistics.debt
                            this.income = this.getCompanyStatistics.income
                            this.bankCard = this.getCompanyStatistics.bankCard
                            this.moneyTransfer = this.getCompanyStatistics.moneyTransfer
                        })
                        .then(() => {
                            this.sortDebtByHours()
                        })
                })
        },
        sortDebtByHours() {
            this.day[0].data = new Array(24).fill(0)

            switch (this.modelFormCurrency) {
                case 'USD':
                    this.dailyStatByUSD()
                    this.exchangeTotalSaleToUSD()
                    this.exchangeCashToUSD()
                    this.exchangeBankCardToUSD()
                    this.exchangeMoneyTransferToUSD()
                    this.exchangeDebtToUSD()
                    this.exchangeIncomeToUSD()
                    break

                case 'RUB':
                    this.dailyStatByRUB()
                    this.exchangeTotalSaleToRUB()
                    this.exchangeCashToRUB()
                    this.exchangeBankCardToRUB()
                    this.exchangeMoneyTransferToRUB()
                    this.exchangeDebtToRUB()
                    this.exchangeIncomeToRUB()
                    break

                case 'UZS':
                    this.dailyStatByUZS()
                    break
            }

            this.series = []
            this.debtSeries = []
            this.series = this.day
            this.debtSeries = this.day
            this.sumSale = 0
            let sum = 0.0

            this.series[0].data.forEach(obj => {
                sum += parseFloat(obj)
            })

            this.sumSale = sum

            this.$apexcharts.exec('1', 'updateOptions', {
                xaxis: {
                    type: 'category',
                    categories: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
                    title: {
                        text: this.$t('statistics.xaxis.hour'),
                    }
                }
            })

            switch (this.modelFormCurrency) {
                case "UZS":
                    this.showDiffSalesBetweenDatesInUZS()
                    this.defineTotalSaleIndexes(this.getCompanyPastStatistics.lastDayTotalSale)
                    this.defineBankCardIndexes(this.getCompanyPastStatistics.lastDayBankCard)
                    this.defineMoneyTransferIndexes(this.getCompanyPastStatistics.lastDayBankCard)
                    this.defineCashIndexes(this.getCompanyPastStatistics.lastDayCash)
                    this.defineDebtIndexes(this.getCompanyPastStatistics.lastDayDebt)
                    this.defineIncomeIndexes(this.getCompanyPastStatistics.lastDayIncome)
                    this.isUZS = true
                    this.isUSD = false
                    this.isRUB = false
                    break

                case "USD":
                    this.showDiffSalesBetweenDatesInUSD()
                    this.defineTotalSaleIndexes(this.getCompanyPastStatistics.lastDayTotalSale, true)
                    this.defineBankCardIndexes(this.getCompanyPastStatistics.lastDayBankCard, true)
                    this.defineMoneyTransferIndexes(this.getCompanyPastStatistics.lastDayBankCard, true)
                    this.defineCashIndexes(this.getCompanyPastStatistics.lastDayCash, true)
                    this.defineDebtIndexes(this.getCompanyPastStatistics.lastDayDebt, true)
                    this.defineIncomeIndexes(this.getCompanyPastStatistics.lastDayIncome, true)
                    this.isUZS = false
                    this.isUSD = true
                    this.isRUB = false
                    break

                case "RUB":
                    this.showDiffSalesBetweenDatesInRUB()
                    this.defineTotalSaleIndexes(this.getCompanyPastStatistics.lastDayTotalSale, true)
                    this.defineBankCardIndexes(this.getCompanyPastStatistics.lastDayBankCard, true)
                    this.defineMoneyTransferIndexes(this.getCompanyPastStatistics.lastDayBankCard, true)
                    this.defineCashIndexes(this.getCompanyPastStatistics.lastDayCash, true)
                    this.defineDebtIndexes(this.getCompanyPastStatistics.lastDayDebt, true)
                    this.defineIncomeIndexes(this.getCompanyPastStatistics.lastDayIncome, true)
                    this.isUZS = false
                    this.isUSD = false
                    this.isRUB = true
                    break
            }
        },
        debtMonthly() {
            this.byMonth = true
            this.byYear = false
            this.datePicker = false
            this.series = []
            this.debtSeries = []
            this.search.startDate = this.selectedYear + '-' + this.selectedMonth.start
            this.search.endDate = this.selectedYear + '-' + this.selectedMonth.end
            console.log(this.search)

            this.searchProductPurchase(this.search)
                .then(() => {
                    console.log(this.getProductPurchases)
                    this.fetchCompanyPayTypeStatistics(this.search)
                    this.fetchCompanyEmployeesSales(this.search)
                    this.fetchCompanyStatistics(this.search)
                        .then(() => {
                            this.totalSale = this.getCompanyStatistics.totalSaleCurrentMonth
                            this.cash = this.getCompanyStatistics.cash
                            this.debt = this.getCompanyStatistics.debt
                            this.income = this.getCompanyStatistics.income
                            this.bankCard = this.getCompanyStatistics.bankCard
                            this.moneyTransfer = this.getCompanyStatistics.moneyTransfer
                        })
                        .then(() => {
                            this.sortDebtByDays()
                        })
                })
        },
        sortDebtByDays() {
            this.month[0].data = new Array(31).fill(0)

            switch (this.modelFormCurrency) {
                case 'USD':
                    this.monthlyStatByUSD()
                    this.exchangeTotalSaleToUSD()
                    this.exchangeCashToUSD()
                    this.exchangeBankCardToUSD()
                    this.exchangeMoneyTransferToUSD()
                    this.exchangeDebtToUSD()
                    this.exchangeIncomeToUSD()
                    break

                case 'RUB':
                    this.monthlyStatByRUB()
                    this.exchangeTotalSaleToRUB()
                    this.exchangeCashToRUB()
                    this.exchangeBankCardToRUB()
                    this.exchangeMoneyTransferToRUB()
                    this.exchangeDebtToRUB()
                    this.exchangeIncomeToRUB()
                    break

                case 'UZS':
                    this.monthlyStatByUZS()
                    break
            }

            this.series = []
            this.debtSeries = []
            this.series = this.month
            this.debtSeries = this.month
            this.sumSale = 0
            let sum = 0.0

            this.series[0].data.forEach(obj => {
                sum += parseFloat(obj)
            })

            this.sumSale = sum

            this.$apexcharts.exec('1', 'updateOptions', {
                xaxis: {
                    title: {
                        text: this.$t('statistics.xaxis.day'),
                    }
                }
            })

            switch (this.modelFormCurrency) {
                case "UZS":
                    this.showDiffSalesBetweenMonthInUZS()
                    this.defineTotalSaleIndexes(this.getCompanyPastStatistics.lastMonthTotalSale)
                    this.defineBankCardIndexes(this.getCompanyPastStatistics.lastMonthBankCard)
                    this.defineMoneyTransferIndexes(this.getCompanyPastStatistics.lastDayBankCard)
                    this.defineCashIndexes(this.getCompanyPastStatistics.lastMonthCash)
                    this.defineDebtIndexes(this.getCompanyPastStatistics.lastMonthDebt)
                    this.defineIncomeIndexes(this.getCompanyPastStatistics.lastMonthIncome)
                    this.isUZS = true
                    this.isUSD = false
                    this.isRUB = false
                    break

                case "USD":
                    this.showDiffSalesBetweenMonthInUSD()
                    this.defineTotalSaleIndexes(this.getCompanyPastStatistics.lastMonthTotalSale, true)
                     this.defineBankCardIndexes(this.getCompanyPastStatistics.lastMonthBankCard, true)
                    this.defineMoneyTransferIndexes(this.getCompanyPastStatistics.lastDayBankCard, true)
                    this.defineCashIndexes(this.getCompanyPastStatistics.lastMonthCash, true)
                    this.defineDebtIndexes(this.getCompanyPastStatistics.lastMonthDebt, true)
                    this.defineIncomeIndexes(this.getCompanyPastStatistics.lastMonthIncome, true)
                    this.isUZS = false
                    this.isUSD = true
                    this.isRUB = false
                    break

                case "RUB":
                    this.showDiffSalesBetweenMonthInRUB()
                    this.defineTotalSaleIndexes(this.getCompanyPastStatistics.lastMonthTotalSale, true)
                     this.defineBankCardIndexes(this.getCompanyPastStatistics.lastMonthBankCard, true)
                    this.defineMoneyTransferIndexes(this.getCompanyPastStatistics.lastDayBankCard, true)
                    this.defineCashIndexes(this.getCompanyPastStatistics.lastMonthCash, true)
                    this.defineDebtIndexes(this.getCompanyPastStatistics.lastMonthDebt, true)
                    this.defineIncomeIndexes(this.getCompanyPastStatistics.lastMonthIncome, true)
                    this.isUZS = false
                    this.isUSD = false
                    this.isRUB = true
                    break
            }
        },
        debtAnnual() {
            this.series = []
            this.debtSeries = []
            this.byMonth = false
            this.byYear = true
            this.datePicker = false
            this.search.startDate = this.selectedYear + '-' + 1 + '-' + 1
            this.search.endDate = this.selectedYear + '-' + 12 + '-' + 31

            console.log(this.search.startDate)
            console.log(this.search.endDate)

            this.searchProductPurchase(this.search)
                .then(() => {
                    console.log(this.getProductPurchases)
                    this.fetchCompanyPayTypeStatistics(this.search)
                    this.fetchCompanyEmployeesSales(this.search)
                    this.fetchCompanyStatistics(this.search)
                        .then(() => {
                            this.totalSale = this.getCompanyStatistics.totalSaleCurrentYear
                            this.cash = this.getCompanyStatistics.cash
                            this.debt = this.getCompanyStatistics.debt
                            this.income = this.getCompanyStatistics.income
                            this.bankCard = this.getCompanyStatistics.bankCard
                            this.moneyTransfer = this.getCompanyStatistics.moneyTransfer
                        })
                        .then(() => {
                            this.sortDebtByMonth()
                        })
                })
        },
        sortDebtByMonth() {
            this.year[0].data = new Array(12).fill(0)

            switch (this.modelFormCurrency) {
                case 'USD':
                    this.yearlyStatByUSD()
                    this.exchangeTotalSaleToUSD()
                    this.exchangeCashToUSD()
                    this.exchangeBankCardToUSD()
                    this.exchangeMoneyTransferToUSD()
                    this.exchangeDebtToUSD()
                    this.exchangeIncomeToUSD()
                    break

                case 'RUB':
                    this.yearlyStatByRUB()
                    this.exchangeTotalSaleToRUB()
                    this.exchangeCashToRUB()
                    this.exchangeBankCardToRUB()
                    this.exchangeMoneyTransferToRUB()
                    this.exchangeDebtToRUB()
                    this.exchangeIncomeToRUB()
                    break

                case 'UZS':
                    this.yearlyStatByUZS()
                    break
            }

            this.series = []
            this.series = this.year
            this.debtSeries = []
            this.debtSeries = this.year
            this.sumSale = 0
            let sum = 0.0

            this.series[0].data.forEach(obj => {
                sum += parseFloat(obj)
            })

            this.sumSale = this.showCurrencyById(null, sum)

            this.$apexcharts.exec('1', 'updateOptions', {
                xaxis: {
                    title: {
                        text: this.$t('statistics.xaxis.month'),
                    }
                }
            })

            switch (this.modelFormCurrency) {
                case "UZS":
                    this.showDiffSalesBetweenYearInUZS()
                    this.defineTotalSaleIndexes(this.getCompanyPastStatistics.lastYearTotalSale)
                    this.defineBankCardIndexes(this.getCompanyPastStatistics.lastYearBankCard)
                    this.defineMoneyTransferIndexes(this.getCompanyPastStatistics.lastDayBankCard)
                    this.defineCashIndexes(this.getCompanyPastStatistics.lastYearCash)
                    this.defineDebtIndexes(this.getCompanyPastStatistics.lastYearDebt)
                    this.defineIncomeIndexes(this.getCompanyPastStatistics.lastYearIncome)
                    this.isUZS = true
                    this.isUSD = false
                    this.isRUB = false
                    break

                case "USD":
                    this.showDiffSalesBetweenYearInUSD()
                    this.defineTotalSaleIndexes(this.getCompanyPastStatistics.lastYearTotalSale, true)
                    this.defineBankCardIndexes(this.getCompanyPastStatistics.lastYearBankCard, true)
                    this.defineMoneyTransferIndexes(this.getCompanyPastStatistics.lastDayBankCard, true)
                    this.defineCashIndexes(this.getCompanyPastStatistics.lastYearCash, true)
                    this.defineDebtIndexes(this.getCompanyPastStatistics.lastYearDebt, true)
                    this.defineIncomeIndexes(this.getCompanyPastStatistics.lastYearIncome, true)
                    this.isUZS = false
                    this.isUSD = true
                    this.isRUB = false
                    break
                case "RUB":
                    this.showDiffSalesBetweenYearInRUB()
                    this.defineTotalSaleIndexes(this.getCompanyPastStatistics.lastYearTotalSale, true)
                    this.defineBankCardIndexes(this.getCompanyPastStatistics.lastYearBankCard, true)
                    this.defineMoneyTransferIndexes(this.getCompanyPastStatistics.lastDayBankCard, true)
                    this.defineCashIndexes(this.getCompanyPastStatistics.lastYearCash, true)
                    this.defineDebtIndexes(this.getCompanyPastStatistics.lastYearDebt, true)
                    this.defineIncomeIndexes(this.getCompanyPastStatistics.lastYearIncome, true)
                    this.isUZS = false
                    this.isUSD = false
                    this.isRUB = true
                    break
            }
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        dateSwitcher() {
            this.selectedMonth = this.optionsMonth[this.currentMonth - 1].value
        },
        createYear() {
            let created = parseInt(this.getUserCompanyCreatedAt)

            while (created <= new Date().getFullYear()) {
                console.log(created)
                this.optionsYear.unshift({value: created, text: created})
                created++
            }

            setTimeout(this.setYear, 500)
        },
        setYear() {
            this.selectedYear = this.optionsYear[0].value
        },
        usdToUzs(product) {
            return this.calculateAmountByBaseCurrency(product.totalPrice, "USD", "UZS")
        },
        rubToUzs(product) {
            return this.calculateAmountByBaseCurrency(product.totalPrice, "RUB", "UZS")
        },
        uzsToUsd(product) {
            return this.calculateAmountByBaseCurrency(product.totalPrice, "UZS", "USD")
        },
        rubToUsd(product) {
            return this.calculateAmountByBaseCurrency(product.totalPrice, "RUB", "USD")
        },
        usdToRub(product) {
            return this.calculateAmountByBaseCurrency(product.totalPrice, "USD", "RUB")
        },
        uzsToRub(product) {
            return this.calculateAmountByBaseCurrency(product.totalPrice, "UZS", "RUB")
        },
        uzsFromValute(currencyName, product, index, period) {
            switch (currencyName) {
                case 'USD':
                    period[0].data[index] += parseInt(this.usdToUzs(product))
                    break

                case 'RUB':
                    period[0].data[index] += parseInt(this.rubToUzs(product))
                    break

                case 'UZS':
                    period[0].data[index] += parseInt(product.totalPrice)
                    break
            }
        },
        usdFromValute(currencyName, product, index, period) {
            switch (currencyName) {
                case 'UZS':
                    period[0].data[index] += parseFloat(this.uzsToUsd(product))
                    break

                case 'RUB':
                    period[0].data[index] += parseFloat(this.rubToUsd(product))
                    break

                case 'USD':
                    period[0].data[index] += parseFloat(product.totalPrice)
                    break
            }
        },
        rubFromValute(currencyName, product, index, period) {
            switch (currencyName) {
                case 'USD':
                    period[0].data[index] += parseFloat(this.usdToRub(product))
                    break

                case 'UZS':
                    period[0].data[index] += parseFloat(this.uzsToRub(product))
                    break

                case 'RUB':
                    period[0].data[index] += parseFloat(product.totalPrice)
                    break
            }
        },
        dailyStatByUZS() {
            this.getProductPurchases.forEach(productPurchase => {
                let date = new Date(productPurchase.createdAt)
                let index = parseInt(date.toString().slice(16, 18))

                if (productPurchase.transaction === null) {
                    this.uzsFromValute(productPurchase.currency.shortName, productPurchase, index, this.day)
                }
            })
        },
        dailyStatByUSD() {
            this.getProductPurchases.forEach(productPurchase => {
                let date = new Date(productPurchase.createdAt)
                let index = parseInt(date.toString().slice(16, 18))

                if (productPurchase.transaction === null) {
                    this.usdFromValute(productPurchase.currency.shortName, productPurchase, index, this.day)
                }
            })
        },
        dailyStatByRUB() {
            this.getProductPurchases.forEach(productPurchase => {
                let date = new Date(productPurchase.createdAt)
                let index = parseInt(date.toString().slice(16, 18))

                if (productPurchase.transaction === null) {
                    this.rubFromValute(productPurchase.currency.shortName, productPurchase, index, this.day)
                }
            })
        },
        monthlyStatByUZS() {
            this.getProductPurchases.forEach(productPurchase => {
                let index = parseInt(productPurchase.createdAt.slice(8, 10))
                index = index - 1

                if (productPurchase.transaction === null) {
                    this.uzsFromValute(productPurchase.currency.shortName, productPurchase, index, this.month)
                }
            })
        },
        monthlyStatByUSD() {
            this.getProductPurchases.forEach(productPurchase => {
                let index = parseInt(productPurchase.createdAt.slice(8, 10))
                index = index - 1

                if (productPurchase.transaction === null) {
                    this.usdFromValute(productPurchase.currency.shortName, productPurchase, index, this.month)
                }
            })
        },
        monthlyStatByRUB() {
            this.getProductPurchases.forEach(productPurchase => {
                let index = parseInt(productPurchase.createdAt.slice(8, 10))
                index = index - 1

                if (productPurchase.transaction === null) {
                    this.rubFromValute(productPurchase.currency.shortName, productPurchase, index, this.month)
                }
            })
        },
        yearlyStatByUZS() {
            this.getProductPurchases.forEach(productPurchase => {
                let index = parseInt(productPurchase.createdAt.slice(5, 7))
                index = index - 1

                if (productPurchase.transaction === null) {
                    this.uzsFromValute(productPurchase.currency.shortName, productPurchase, index, this.year)
                }
            })
        },
        yearlyStatByUSD() {
            this.getProductPurchases.forEach(productPurchase => {
                let index = parseInt(productPurchase.createdAt.slice(5, 7))
                index = index - 1

                if (productPurchase.transaction === null) {
                    this.usdFromValute(productPurchase.currency.shortName, productPurchase, index, this.year)
                }
            })
        },
        yearlyStatByRUB() {
            this.getProductPurchases.forEach(productPurchase => {
                let index = parseInt(productPurchase.createdAt.slice(5, 7))
                index = index - 1

                if (productPurchase.transaction === null) {
                    this.rubFromValute(productPurchase.currency.shortName, productPurchase, index, this.year)
                }
            })
        },
        showDiffSalesBetweenDatesInUZS() {
            this.diffTotalSale = this.getCompanyPastStatistics.lastDayTotalSale > this.totalSale ?
                this.totalSale * 100 / this.getCompanyPastStatistics.lastDayTotalSale - 100 :
                this.getCompanyPastStatistics.lastDayTotalSale * 100 / this.totalSale - 100
            this.diffCash = this.getCompanyPastStatistics.lastDayCash > this.cash ?
                this.cash * 100 / this.getCompanyPastStatistics.lastDayCash - 100 :
                this.getCompanyPastStatistics.lastDayCash * 100 / this.cash - 100
            this.diffDebt = this.getCompanyPastStatistics.lastDayDebt > this.debt ?
                this.debt * 100 / this.getCompanyPastStatistics.lastDayDebt - 100 :
                this.getCompanyPastStatistics.lastDayDebt * 100 / this.debt - 100
            this.diffIncome = this.getCompanyPastStatistics.lastDayIncome > this.income ?
                this.income * 100 / this.getCompanyPastStatistics.lastDayIncome - 100 :
                this.getCompanyPastStatistics.lastDayIncome * 100 / this.income - 100
            this.diffBankCard = this.getCompanyPastStatistics.lastDayBankCard > this.bankCard ?
                this.bankCard * 100 / this.getCompanyPastStatistics.lastDayBankCard - 100 :
                this.getCompanyPastStatistics.lastDayBankCard * 100 / this.bankCard -100
            this.diffMoneyTransfer = this.getCompanyPastStatistics.lastDayMoneyTransfer > this.moneyTransfer ?
                this.moneyTransfer * 100 / this.getCompanyPastStatistics.lastDayMoneyTransfer - 100 :
                this.getCompanyPastStatistics.lastDayMoneyTransfer * 100 / this.moneyTransfer -100
        },
        showDiffSalesBetweenMonthInUZS() {
            this.diffTotalSale = this.getCompanyPastStatistics.lastMonthTotalSale > this.totalSale ?
                this.totalSale * 100 / this.getCompanyPastStatistics.lastMonthTotalSale - 100 :
                this.getCompanyPastStatistics.lastMonthTotalSale * 100 / this.totalSale - 100
            this.diffCash = this.getCompanyPastStatistics.lastMonthCash > this.cash ?
                this.cash * 100 / this.getCompanyPastStatistics.lastMonthCash - 100 :
                this.getCompanyPastStatistics.lastMonthCash * 100 / this.cash - 100
            this.diffDebt = this.getCompanyPastStatistics.lastMonthDebt > this.debt ?
                this.debt * 100 / this.getCompanyPastStatistics.lastMonthDebt - 100 :
                this.getCompanyPastStatistics.lastMonthDebt * 100 / this.debt - 100
            this.diffIncome = this.getCompanyPastStatistics.lastMonthIncome > this.income ?
                this.income * 100 / this.getCompanyPastStatistics.lastMonthIncome - 100 :
                this.getCompanyPastStatistics.lastMonthIncome * 100 / this.income - 100
            this.diffBankCard = this.getCompanyPastStatistics.lastMonthBankCard > this.bankCard ?
                this.bankCard * 100 / this.getCompanyPastStatistics.lastMonthBankCard - 100 :
                this.getCompanyPastStatistics.lastMonthBankCard * 100 / this.bankCard -100
            this.diffMoneyTransfer = this.getCompanyPastStatistics.lastMonthMoneyTransfer > this.moneyTransfer ?
                this.moneyTransfer * 100 / this.getCompanyPastStatistics.lastMonthMoneyTransfer - 100 :
                this.getCompanyPastStatistics.lastMonthMoneyTransfer * 100 / this.moneyTransfer -100
        },
        showDiffSalesBetweenYearInUZS() {
            this.diffTotalSale = this.getCompanyPastStatistics.lastYearTotalSale > this.totalSale ?
                this.totalSale * 100 / this.getCompanyPastStatistics.lastYearTotalSale - 100 :
                this.getCompanyPastStatistics.lastYearTotalSale * 100 / this.totalSale - 100
            this.diffCash = this.getCompanyPastStatistics.lastYearCash > this.cash ?
                this.cash * 100 / this.getCompanyPastStatistics.lastYearCash - 100 :
                this.getCompanyPastStatistics.lastYearCash * 100 / this.cash - 100
            this.diffDebt = this.getCompanyPastStatistics.lastYearDebt > this.debt ?
                this.debt * 100 / this.getCompanyPastStatistics.lastYearDebt - 100 :
                this.getCompanyPastStatistics.lastYearDebt * 100 / this.debt - 100
            this.diffIncome = this.getCompanyPastStatistics.lastYearIncome > this.income ?
                this.income * 100 / this.getCompanyPastStatistics.lastYearIncome - 100 :
                this.getCompanyPastStatistics.lastYearIncome * 100 / this.income - 100
            this.diffBankCard = this.getCompanyPastStatistics.lastYearBankCard > this.bankCard ?
                this.bankCard * 100 / this.getCompanyPastStatistics.lastYearBankCard - 100 :
                this.getCompanyPastStatistics.lastYearBankCard * 100 / this.bankCard -100
            this.diffMoneyTransfer = this.getCompanyPastStatistics.lastYearMoneyTransfer > this.moneyTransfer ?
                this.moneyTransfer * 100 / this.getCompanyPastStatistics.lastYearMoneyTransfer - 100 :
                this.getCompanyPastStatistics.lastYearMoneyTransfer * 100 / this.moneyTransfer -100
        },
        showDiffSalesBetweenDatesInUSD() {
            this.diffTotalSale = (this.getCompanyPastStatistics.lastDayTotalSale / this.getCompanyOrOfficialRate('USD')) > this.totalSale ?
                this.totalSale * 100 / (this.getCompanyPastStatistics.lastDayTotalSale / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastDayTotalSale / this.getCompanyOrOfficialRate('USD')) * 100 / this.totalSale - 100
            this.diffCash = (this.getCompanyPastStatistics.lastDayCash / this.getCompanyOrOfficialRate('USD')) > this.cash ?
                this.cash * 100 / (this.getCompanyPastStatistics.lastDayCash / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastDayCash / this.getCompanyOrOfficialRate('USD')) * 100 / this.cash - 100
            this.diffDebt = (this.getCompanyPastStatistics.lastDayDebt / this.getCompanyOrOfficialRate('USD')) > this.debt ?
                this.debt * 100 / (this.getCompanyPastStatistics.lastDayDebt / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastDayDebt / this.getCompanyOrOfficialRate('USD')) * 100 / this.debt - 100
            this.diffIncome = (this.getCompanyPastStatistics.lastDayIncome / this.getCompanyOrOfficialRate('USD')) > this.income ?
                this.income * 100 / (this.getCompanyPastStatistics.lastDayIncome / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastDayIncome / this.getCompanyOrOfficialRate('USD')) * 100 / this.income - 100
            this.diffBankCard = (this.getCompanyPastStatistics.lastDayBankCard / this.getCompanyOrOfficialRate('USD')) > this.bankCard ?
                this.bankCard * 100 / (this.getCompanyPastStatistics.lastDayBankCard / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastDayBankCard / this.getCompanyOrOfficialRate('USD')) * 100 / this.bankCard -100
            this.diffMoneyTransfer = (this.getCompanyPastStatistics.lastDayMoneyTransfer / this.getCompanyOrOfficialRate('USD')) > this.moneyTransfer ?
                this.moneyTransfer * 100 / (this.getCompanyPastStatistics.lastDayMoneyTransfer / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastDayMoneyTransfer / this.getCompanyOrOfficialRate('USD')) * 100 / this.moneyTransfer -100
        },
        showDiffSalesBetweenMonthInUSD() {
            this.diffTotalSale = (this.getCompanyPastStatistics.lastMonthTotalSale / this.getCompanyOrOfficialRate('USD')) > this.totalSale ?
                this.totalSale * 100 / (this.getCompanyPastStatistics.lastMonthTotalSale / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastMonthTotalSale / this.getCompanyOrOfficialRate('USD')) * 100 / this.totalSale - 100
            this.diffCash = (this.getCompanyPastStatistics.lastMonthCash / this.getCompanyOrOfficialRate('USD')) > this.cash ?
                this.cash * 100 / (this.getCompanyPastStatistics.lastMonthCash / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastMonthCash / this.getCompanyOrOfficialRate('USD')) * 100 / this.cash - 100
            this.diffDebt = (this.getCompanyPastStatistics.lastMonthDebt / this.getCompanyOrOfficialRate('USD')) > this.debt ?
                this.debt * 100 / (this.getCompanyPastStatistics.lastMonthDebt / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastMonthDebt / this.getCompanyOrOfficialRate('USD')) * 100 / this.debt - 100
            this.diffIncome = (this.getCompanyPastStatistics.lastMonthIncome / this.getCompanyOrOfficialRate('USD')) > this.income ?
                this.income * 100 / (this.getCompanyPastStatistics.lastMonthIncome / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastMonthIncome / this.getCompanyOrOfficialRate('USD')) * 100 / this.income - 100
            this.diffBankCard = (this.getCompanyPastStatistics.lastMonthBankCard / this.getCompanyOrOfficialRate('USD')) > this.bankCard ?
                this.bankCard * 100 / (this.getCompanyPastStatistics.lastMonthBankCard / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastMonthBankCard / this.getCompanyOrOfficialRate('USD')) * 100 / this.bankCard -100
            this.diffMoneyTransfer = (this.getCompanyPastStatistics.lastMonthMoneyTransfer / this.getCompanyOrOfficialRate('USD')) > this.moneyTransfer ?
                this.moneyTransfer * 100 / (this.getCompanyPastStatistics.lastMonthMoneyTransfer / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastMonthMoneyTransfer / this.getCompanyOrOfficialRate('USD')) * 100 / this.moneyTransfer -100
        },
        showDiffSalesBetweenYearInUSD() {
            this.diffTotalSale = (this.getCompanyPastStatistics.lastYearTotalSale / this.getCompanyOrOfficialRate('USD')) > this.totalSale ?
                this.totalSale * 100 / (this.getCompanyPastStatistics.lastYearTotalSale / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastYearTotalSale / this.getCompanyOrOfficialRate('USD')) * 100 / this.totalSale - 100
            this.diffCash = (this.getCompanyPastStatistics.lastYearCash / this.getCompanyOrOfficialRate('USD')) > this.cash ?
                this.cash * 100 / (this.getCompanyPastStatistics.lastYearCash / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastYearCash / this.getCompanyOrOfficialRate('USD')) * 100 / this.cash - 100
            this.diffDebt = (this.getCompanyPastStatistics.lastYearDebt / this.getCompanyOrOfficialRate('USD')) > this.debt ?
                this.debt * 100 / (this.getCompanyPastStatistics.lastYearDebt / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastYearDebt / this.getCompanyOrOfficialRate('USD')) * 100 / this.debt - 100
            this.diffIncome = (this.getCompanyPastStatistics.lastYearIncome / this.getCompanyOrOfficialRate('USD')) > this.income ?
                this.income * 100 / (this.getCompanyPastStatistics.lastYearIncome / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastYearIncome / this.getCompanyOrOfficialRate('USD')) * 100 / this.income - 100
            this.diffBankCard = (this.getCompanyPastStatistics.lastYearBankCard / this.getCompanyOrOfficialRate('USD')) > this.bankCard ?
                this.bankCard * 100 / (this.getCompanyPastStatistics.lastYearBankCard / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastYearBankCard / this.getCompanyOrOfficialRate('USD')) * 100 / this.bankCard -100
            this.diffMoneyTransfer = (this.getCompanyPastStatistics.lastYearMoneyTransfer / this.getCompanyOrOfficialRate('USD')) > this.moneyTransfer ?
                this.moneyTransfer * 100 / (this.getCompanyPastStatistics.lastYearMoneyTransfer / this.getCompanyOrOfficialRate('USD')) - 100 :
                (this.getCompanyPastStatistics.lastYearMoneyTransfer / this.getCompanyOrOfficialRate('USD')) * 100 / this.moneyTransfer -100
        },
        showDiffSalesBetweenDatesInRUB() {
            this.diffTotalSale = (this.getCompanyPastStatistics.lastDayTotalSale / this.getCompanyOrOfficialRate('RUB')) > this.totalSale ?
                this.totalSale * 100 / (this.getCompanyPastStatistics.lastDayTotalSale / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastDayTotalSale / this.getCompanyOrOfficialRate('RUB')) * 100 / this.totalSale - 100
            this.diffCash = (this.getCompanyPastStatistics.lastDayCash / this.getCompanyOrOfficialRate('RUB')) > this.cash ?
                this.cash * 100 / (this.getCompanyPastStatistics.lastDayCash / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastDayCash / this.getCompanyOrOfficialRate('RUB')) * 100 / this.cash - 100
            this.diffDebt = (this.getCompanyPastStatistics.lastDayDebt / this.getCompanyOrOfficialRate('RUB')) > this.debt ?
                this.debt * 100 / (this.getCompanyPastStatistics.lastDayDebt / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastDayDebt / this.getCompanyOrOfficialRate('RUB')) * 100 / this.debt - 100
            this.diffIncome = (this.getCompanyPastStatistics.lastDayIncome / this.getCompanyOrOfficialRate('RUB')) > this.income ?
                this.income * 100 / (this.getCompanyPastStatistics.lastDayIncome / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastDayIncome / this.getCompanyOrOfficialRate('RUB')) * 100 / this.income - 100
            this.diffBankCard = (this.getCompanyPastStatistics.lastDayBankCard / this.getCompanyOrOfficialRate('RUB')) > this.bankCard ?
                this.bankCard * 100 / (this.getCompanyPastStatistics.lastDayBankCard / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastDayBankCard / this.getCompanyOrOfficialRate('RUB')) * 100 / this.bankCard -100
            this.diffMoneyTransfer = (this.getCompanyPastStatistics.lastDayMoneyTransfer / this.getCompanyOrOfficialRate('RUB')) > this.moneyTransfer ?
                this.moneyTransfer * 100 / (this.getCompanyPastStatistics.lastDayMoneyTransfer / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastDayMoneyTransfer / this.getCompanyOrOfficialRate('RUB')) * 100 / this.moneyTransfer -100
        },
        showDiffSalesBetweenMonthInRUB() {
            this.diffTotalSale = (this.getCompanyPastStatistics.lastMonthTotalSale / this.getCompanyOrOfficialRate('RUB')) > this.totalSale ?
                this.totalSale * 100 / (this.getCompanyPastStatistics.lastMonthTotalSale / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastMonthTotalSale / this.getCompanyOrOfficialRate('RUB')) * 100 / this.totalSale - 100
            this.diffCash = (this.getCompanyPastStatistics.lastMonthCash / this.getCompanyOrOfficialRate('RUB')) > this.cash ?
                this.cash * 100 / (this.getCompanyPastStatistics.lastMonthCash / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastMonthCash / this.getCompanyOrOfficialRate('RUB')) * 100 / this.cash - 100
            this.diffDebt = (this.getCompanyPastStatistics.lastMonthDebt / this.getCompanyOrOfficialRate('RUB')) > this.debt ?
                this.debt * 100 / (this.getCompanyPastStatistics.lastMonthDebt / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastMonthDebt / this.getCompanyOrOfficialRate('RUB')) * 100 / this.debt - 100
            this.diffIncome = (this.getCompanyPastStatistics.lastMonthIncome / this.getCompanyOrOfficialRate('RUB')) > this.income ?
                this.income * 100 / (this.getCompanyPastStatistics.lastMonthIncome / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastMonthIncome / this.getCompanyOrOfficialRate('RUB')) * 100 / this.income - 100
            this.diffBankCard = (this.getCompanyPastStatistics.lastMonthBankCard / this.getCompanyOrOfficialRate('RUB')) > this.bankCard ?
                this.bankCard * 100 / (this.getCompanyPastStatistics.lastMonthBankCard / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastMonthBankCard / this.getCompanyOrOfficialRate('RUB')) * 100 / this.bankCard -100
            this.diffMoneyTransfer = (this.getCompanyPastStatistics.lastMonthMoneyTransfer / this.getCompanyOrOfficialRate('RUB')) > this.moneyTransfer ?
                this.moneyTransfer * 100 / (this.getCompanyPastStatistics.lastMonthMoneyTransfer / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastMonthMoneyTransfer / this.getCompanyOrOfficialRate('RUB')) * 100 / this.moneyTransfer -100
        },
        showDiffSalesBetweenYearInRUB() {
            this.diffTotalSale = (this.getCompanyPastStatistics.lastYearTotalSale / this.getCompanyOrOfficialRate('RUB')) > this.totalSale ?
                this.totalSale * 100 / (this.getCompanyPastStatistics.lastYearTotalSale / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastYearTotalSale / this.getCompanyOrOfficialRate('RUB')) * 100 / this.totalSale - 100
            this.diffCash = (this.getCompanyPastStatistics.lastYearCash / this.getCompanyOrOfficialRate('RUB')) > this.cash ?
                this.cash * 100 / (this.getCompanyPastStatistics.lastYearCash / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastYearCash / this.getCompanyOrOfficialRate('RUB')) * 100 / this.cash - 100
            this.diffDebt = (this.getCompanyPastStatistics.lastYearDebt / this.getCompanyOrOfficialRate('RUB')) > this.debt ?
                this.debt * 100 / (this.getCompanyPastStatistics.lastYearDebt / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastYearDebt / this.getCompanyOrOfficialRate('RUB')) * 100 / this.debt - 100
            this.diffIncome = (this.getCompanyPastStatistics.lastYearIncome / this.getCompanyOrOfficialRate('RUB')) > this.income ?
                this.income * 100 / (this.getCompanyPastStatistics.lastYearIncome / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastYearIncome / this.getCompanyOrOfficialRate('RUB')) * 100 / this.income - 100
            this.diffBankCard = (this.getCompanyPastStatistics.lastYearBankCard / this.getCompanyOrOfficialRate('RUB')) > this.bankCard ?
                this.bankCard * 100 / (this.getCompanyPastStatistics.lastYearBankCard / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastYearBankCard / this.getCompanyOrOfficialRate('RUB')) * 100 / this.bankCard -100
            this.diffMoneyTransfer = (this.getCompanyPastStatistics.lastYearMoneyTransfer / this.getCompanyOrOfficialRate('RUB')) > this.moneyTransfer ?
                this.moneyTransfer * 100 / (this.getCompanyPastStatistics.lastYearMoneyTransfer / this.getCompanyOrOfficialRate('RUB')) - 100 :
                (this.getCompanyPastStatistics.lastYearMoneyTransfer / this.getCompanyOrOfficialRate('RUB')) * 100 / this.moneyTransfer -100
        },
        defineTotalSaleIndexes(lastSale, needToConvert) {
            if (needToConvert) {
                switch (this.modelFormCurrency) {
                    case "USD":
                        this.totalSale > (lastSale / this.getCompanyOrOfficialRate('USD')) ? this.hasIncreaseTotalSale = true : this.hasIncreaseTotalSale = false
                        break
                    case "RUB":
                        this.totalSale > (lastSale / this.getCompanyOrOfficialRate('RUB')) ? this.hasIncreaseTotalSale = true : this.hasIncreaseTotalSale = false
                        break
                }

                return
            }

            this.totalSale > lastSale ? this.hasIncreaseTotalSale = true : this.hasIncreaseTotalSale = false
        },
        defineCashIndexes(lastCash, needToConvert) {
            if (needToConvert) {
                switch (this.modelFormCurrency) {
                    case "USD":
                        this.cash > (lastCash / this.getCompanyOrOfficialRate('USD')) ? this.hasIncreaseCash = true : this.hasIncreaseCash = false
                        break
                    case "RUB":
                        this.cash > (lastCash / this.getCompanyOrOfficialRate('RUB')) ? this.hasIncreaseCash = true : this.hasIncreaseCash = false
                        break
                }

                return
            }

            this.cash > lastCash ? this.hasIncreaseCash = true : this.hasIncreaseCash = false
        },
        defineBankCardIndexes(lastBankCard, needToConvert) {
            if (needToConvert) {
                switch (this.modelFormCurrency) {
                    case "USD":
                        this.bankCard > (lastBankCard / this.getCompanyOrOfficialRate('USD')) ? this.hasIncreaseBankCard = true : this.hasIncreaseBankCard = false
                        break
                    case "RUB":
                        this.bankCard > (lastBankCard / this.getCompanyOrOfficialRate('RUB')) ? this.hasIncreaseBankCard = true : this.hasIncreaseBankCard = false
                        break
                }

                return
            }

            this.bankCard > lastBankCard ? this.hasIncreaseBankCard = true : this.hasIncreaseBankCard = false
        },
        defineMoneyTransferIndexes(lastMoneyTransfer, needToConvert) {
            if (needToConvert) {
                switch (this.modelFormCurrency) {
                    case "USD":
                        this.moneyTransfer > (lastMoneyTransfer / this.getCompanyOrOfficialRate('USD')) ? this.hasIncreaseMoneyTransfer = true : this.hasIncreaseMoneyTransfer = false
                        break
                    case "RUB":
                        this.moneyTransfer > (lastMoneyTransfer / this.getCompanyOrOfficialRate('RUB')) ? this.hasIncreaseMoneyTransfer = true : this.hasIncreaseMoneyTransfer = false
                        break
                }

                return
            }

            this.bankCard > lastMoneyTransfer ? this.hasIncreaseMoneyTransfer = true : this.hasIncreaseMoneyTransfer = false
        },
        defineDebtIndexes(lastDebt, needToConvert) {
            if (needToConvert) {
                switch (this.modelFormCurrency) {
                    case "USD":
                        this.debt > (lastDebt / this.getCompanyOrOfficialRate('USD')) ? this.hasIncreaseDebt = true : this.hasIncreaseDebt = false
                        break
                    case "RUB":
                        this.debt > (lastDebt / this.getCompanyOrOfficialRate('RUB')) ? this.hasIncreaseDebt = true : this.hasIncreaseDebt = false
                        break
                }

                return
            }

            this.debt > lastDebt ? this.hasIncreaseDebt = true : this.hasIncreaseDebt = false
        },
        defineIncomeIndexes(lastIncome, needToConvert) {
            if (needToConvert) {
                switch (this.modelFormCurrency) {
                    case "USD":
                        this.income > (lastIncome / this.getCompanyOrOfficialRate('USD')) ? this.hasIncreaseIncome = true : this.hasIncreaseIncome = false
                        break
                    case 'RUB':
                        this.income > (lastIncome / this.getCompanyOrOfficialRate('RUB')) ? this.hasIncreaseIncome = true : this.hasIncreaseIncome = false
                        break
                }

                return
            }

            this.income > lastIncome ? this.hasIncreaseIncome = true : this.hasIncreaseIncome = false
        },
    },
    mounted() {
        this.$root.showOverlay = true
        let yearNow = new Date().getFullYear()
        let monthNow = new Date().getMonth()
        let dateNow = new Date().getDate()
        this.currentDate = yearNow + '-' + (monthNow + 1) + '-' + ('0' + dateNow).slice(-2)
        this.currentMonth = new Date().getUTCMonth() + 1
        this.dateSwitcher()
        setTimeout(this.createYear, 1000)
        let date = new Date(this.currentDate)
        this.search.startDate = date.toISOString()
        this.search.endDate = this.currentDate + ' ' + '18:59:59'

        this.fetchCompanyPastStatistics()
        this.fetchCompanyPayTypeStatistics(this.search)
        this.fetchCompanyEmployeesSales(this.search)
        this.fetchCompanyStatistics(this.search)
            .then(() => {
                this.debtDaily()
                this.employeeId = this.getCompanyEmployeesSale.length === 0 ? null : this.getCompanyEmployeesSale[0].id
                this.$root.showOverlay = false
                this.rateUSD = this.getCompanyOrOfficialRate('USD')
                this.rateRUB = this.getCompanyOrOfficialRate('RUB')
            })
    }
}

</script>

<style scoped>

.progress {
    width: 60%;
}

.divider {
    border-bottom: 1px solid #d2d2d2 !important;
    width: 100%;
}

.card {
    width: 200px;
    height: 129px;
    border: 1px solid #707070;
}

.card-pay-type {
    width: 220px;
    min-height: 165px;
    border: 1px solid #707070;
    border-radius: 5px;
}

.picture {
    height: 70px;
    width: 70px;
    object-fit: contain;
    border-radius: 50%;
}

.employee-card {
    border: 1px solid #d2d2d2;
    border-radius: 5px;
    padding: 5px;
}

.employee-name {
    font-size: 16px;
    font-weight: 700;
    color: #000000;
    padding-top: 4px;
    line-height: 0.7;
}

.position {
    font-size: 14px;
    font-weight: 600;
    color: #707070;
}

.active {
    border: 3px solid #6f42c1;
}

.button-stat {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background-color: #E5E5E5;
    color: #707070;
    font-size: 12px;
    height: 30px;
}

.button-stat:checked:active:focus {
    background-color: #6f42c1 !important;
}

.button-stat:active {
    background-color: #6f42c1 !important;
}

.indicator-title {
    font-size: 16px;
    font-weight: 700;
    color: #000000;
}

.indicator-range {
    font-size: 14px;
    font-weight: 400;
    color: #000000;
}

.indicator-total {
    font-size: 18px;
    font-weight: 700;
    color: #8300C5;
}

.indicator {
    border-right: #444444 solid 1px;
    background-color: #F0EEF9;
    padding: 10px 0 10px 20px;
    margin: 1px 0;
}

.subtitle, .percent {
    font-size: 13px;
    color: #707070;
    font-weight: 600;
}

.subtitle {
    width: 15%;
}

.percent {
    width: 5%;
}
</style>
